import { WordCloudComponent } from '../charts/word-cloud-component'

export class AFNegativeWordCloud extends WordCloudComponent {
 static config = {
  selector: 'afNegativeWordCloud',
  controller: AFNegativeWordCloud,
  bindings: WordCloudComponent.config.bindings,
  template: WordCloudComponent.config.template,
 }

 setProperties() {
  this.seriesColors = '#FF7171'
 }

 onPointClick = event => {
  console.log('this :', event)
  this.triggerUpdate(
   this.updatePayload(
    'FILTER_CHANGE',
    'append',
    'subKeyword',
    this.getOriginalTerm(event.key, this.vizData.data.all)
   )
  )
  this.triggerUpdate(this.updatePayload('FILTER_CHANGE', 'append', 'sentiment', 'v'))
 }
}
